import { render } from "./FileDrop.vue?vue&type=template&id=08fb5990&ts=true"
import script from "./FileDrop.vue?vue&type=script&lang=ts"
export * from "./FileDrop.vue?vue&type=script&lang=ts"

import "./FileDrop.vue?vue&type=style&index=0&id=08fb5990&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__